// extracted by mini-css-extract-plugin
export var actionButton = "_e9-t";
export var buttonContainer = "_e9-0";
export var buttonContainer2 = "_e9-1";
export var buttonSection = "_e9-2";
export var details = "_e9-3";
export var dropdownItem = "_e9-5";
export var dropdownItemsContainer = "_e9-4";
export var fileInput = "_e9-r";
export var headerButton = "_e9-6";
export var icon = "_e9-7";
export var input = "_e9-8";
export var macroListItem = "_e9-9";
export var mainContent = "_e9-a";
export var microText = "_e9-b";
export var modal = "_e9-w";
export var optionsButton = "_e9-c";
export var paperclip = "_e9-s";
export var pillContent = "_e9-d";
export var preview = "_e9-e";
export var preview2 = "_e9-f";
export var quillEditor = "_e9-q";
export var selectedMacro = "_e9-g";
export var sidebar = "_e9-h";
export var sidebarHeader = "_e9-j";
export var sidebarList = "_e9-i";
export var sidebarListItem = "_e9-k";
export var sidebarSearch = "_e9-l";
export var snoozeDurationWrapper = "_e9-v";
export var statusPillContainer = "_e9-m";
export var tagsContainer = "_e9-n";
export var unselectedMacro = "_e9-o";
export var variable = "_e9-u";
export var wrapper = "_e9-p";